<script>
    export let project = {
        id: '',
        title: '',
        summary: '',
        tags: [],
        people:[],
    }

    import {Link} from "svelte-routing";

    import Tag from './Tag.svelte';
    import ButtonMore from './ButtonMore.svelte';
</script>

<div class="card card-project">
    <div class="card-image">
        <ButtonMore to="projects/{project.id}"/>
        <Link to="projects/{project.id}">
           <img src="/content/icons/Icon_{project.id}.png" alt="{project.id}">
        </Link>
    </div>
    <div class="card-content">
        {#each project.tags as tag}
            <Tag {tag}/>
        {/each}
        <span class="card-title"><b>{project.id}</b> {project.title}</span>
        <p class="summary">{project.summary.substring(0, 300) + "..."}</p>
    </div>
</div>

<style>
    img {
        object-fit: cover;
        width:320px;
        height:180px;
    }

    .card-project {
        min-height: 680px;
    }
    p.summary{
        text-align: justify;
    }
</style>
